import { render } from "./ThaiNguyen.vue?vue&type=template&id=4a2b14da&scoped=true"
import script from "./ThaiNguyen.vue?vue&type=script&scoped=true&lang=js"
export * from "./ThaiNguyen.vue?vue&type=script&scoped=true&lang=js"

import "./ThaiNguyen.vue?vue&type=style&index=0&id=4a2b14da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2b14da"]])

export default __exports__